import { render, staticRenderFns } from "./OrgSettingsEvaluate.vue?vue&type=template&id=3dddda12&scoped=true&"
import script from "./OrgSettingsEvaluate.vue?vue&type=script&lang=js&"
export * from "./OrgSettingsEvaluate.vue?vue&type=script&lang=js&"
import style0 from "./OrgSettingsEvaluate.vue?vue&type=style&index=0&id=3dddda12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dddda12",
  null
  
)

export default component.exports